import React from 'react';
import { Message } from 'talkplus-sdk/dist/model/types';
import styles from '@components/chat/chatDetail/messageList/index.module.scss';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

interface AdminTextMessageProps {
  message: Message;
}

const AdminTextMessage = ({ message }: AdminTextMessageProps) => {
  const text = message.text || null;

  {
    /* 복사하기를 위한 id */
  }
  return (
    <span id={message.id} className={cx('message')}>
      {text}
    </span>
  );
};

export default AdminTextMessage;
